/* WeldRda — extras (travail 13), loaded after wr.js:
   1. Product cards: tap a colour = its photo, its sizes in stock, its link (snippets/wr-product-card).
   2. Review form without email (snippets/wr-review-form): the client chooses how the name is shown.
   3. Product page on computer: photos in a grid, the shorter column stays in view (no empty space).
   4. Product page on phones: peeking photo slider and closed description (shorter page).
   5. Ad visitors: no Instagram / TikTok links, so they order at the price shown (WhatsApp stays).
   6. Product photos: tap or click to open full screen and zoom (pinch, double-tap, click). */
(function () {
'use strict';
/* Ad visitors. A visit from a paid ad (utm_medium=paid / cpc / ppc / cpm / ads / paid_social, or a TikTok/Google
   click id) adds the class "wr-from-ads" on <html> for 30 days; assets/wr-plus.css then hides the Instagram and
   TikTok links. A visit from the Instagram or TikTok bio/stories (utm_source=instagram or tiktok, without a paid
   medium) removes it, because that client already follows the account.
   Test: ?wr_ads=1 turns it on, ?wr_ads=0 turns it off. Runs at once (no wait) so the links never flash. */
function initAdVisitors() {
var KEY = 'wr-ads', MAX = 30 * 864e5, now = Date.now(), paid = false, organic = false, off = false, t = 0;
try {
  var p = new URLSearchParams(location.search);
  var medium = (p.get('utm_medium') || '').toLowerCase(), source = (p.get('utm_source') || '').toLowerCase();
  paid = p.get('wr_ads') === '1' || /^(paid|paid[_-]?social|cpc|ppc|cpm|ads?)$/.test(medium) || p.has('ttclid') || p.has('gclid');
  off = p.get('wr_ads') === '0';
  organic = !paid && (off || /^(instagram|ig|tiktok)$/.test(source));
} catch (e) {}
[function () { return window.localStorage; }, function () { return window.sessionStorage; }].forEach(function (get) {
  try {
    var s = get();
    if (paid) s.setItem(KEY, String(now));
    else if (organic) s.removeItem(KEY);
    var v = parseInt(s.getItem(KEY), 10) || 0;
    if (v && now - v >= MAX) { s.removeItem(KEY); v = 0; }
    if (v > t) t = v;
  } catch (e) {}
});
document.documentElement.classList.toggle('wr-from-ads', paid || (!organic && t > 0));
}
initAdVisitors();

/* Product cards: tap a colour to see its photo, its sizes in stock and open the product in that colour.
   Data comes from <script data-card-data> in snippets/wr-product-card.liquid. One listener for all cards,
   so cards added later (filters, section reloads) work too. */
function initCards() {
if (window.__wrCards) return;
window.__wrCards = true;
var W = [360, 540, 720, 900];
function data(card) {
  if (!card.__wr) {
    var el = card.querySelector('script[data-card-data]');
    try { card.__wr = JSON.parse(el ? el.textContent : '[]'); } catch (e) { card.__wr = []; }
  }
  return card.__wr;
}
function srcset(u) {
  return W.map(function (w) { return u.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
}
function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
function pick(btn) {
  var card = btn.closest('[data-wr-card]');
  if (!card) return;
  var d = data(card)[+btn.getAttribute('data-card-color')];
  if (!d) return;
  card.querySelectorAll('[data-card-color]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
  var link = card.querySelector('[data-card-link]');
  if (link && d.u) link.href = d.u;
  var img = card.querySelector('.wr-card__img:not(.wr-card__img--hover)');
  var hov = card.querySelector('.wr-card__img--hover');
  if (img && d.i) { img.srcset = srcset(d.i); img.src = d.i; }
  if (d.h && img) {
    if (!hov) {
      hov = img.cloneNode(false);
      hov.className = 'wr-card__img wr-card__img--hover';
      hov.alt = '';
      hov.loading = 'lazy';
      img.parentNode.insertBefore(hov, img.nextSibling);
    }
    hov.hidden = false; hov.srcset = srcset(d.h); hov.src = d.h;
  } else if (hov) { hov.hidden = true; }
  var sz = card.querySelector('[data-card-sizes]');
  if (sz) {
    if (d.s && d.s.length) {
      sz.classList.remove('is-none');
      sz.setAttribute('aria-label', 'Tailles disponibles : ' + d.s.join(', '));
      sz.innerHTML = d.s.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('<i aria-hidden="true">·</i>');
    } else {
      sz.classList.add('is-none');
      sz.removeAttribute('aria-label');
      sz.textContent = 'Épuisé dans cette couleur';
    }
  }
}
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-wr-card] [data-card-color]');
  if (!btn) return;
  e.preventDefault();
  pick(btn);
});
/* Load the photo before the tap (mouse hover or keyboard focus) so the switch feels instant. */
function warm(e) {
  var btn = e.target.closest && e.target.closest('[data-wr-card] [data-card-color]');
  if (!btn || btn.__warm) return;
  btn.__warm = true;
  var card = btn.closest('[data-wr-card]');
  var d = data(card)[+btn.getAttribute('data-card-color')];
  var img = card.querySelector('.wr-card__img');
  if (d && d.i) { var im = new Image(); if (img && img.sizes) im.sizes = img.sizes; im.srcset = srcset(d.i); }
}
document.addEventListener('pointerover', warm);
document.addEventListener('focusin', warm);
}

/* WeldRda review form (snippets/wr-review-form): puts the store email when the client gives none
   (Shopify's contact form needs one), checks the phone, and writes the "Code avis" line that
   WeldRda_Avis_JudgeMe.html reads to build the Judge.me import file. */
function initReviews() {
if (window.__wrRev) return;
window.__wrRev = true;
/* Name shown with the review: "Y." (initiale), "Youssef" (prénom) or "Client Weld Rda" (anonyme).
   Same rule in WeldRda_Avis_JudgeMe.html. */
function shownName(n, mode) {
  var first = String(n || '').trim().split(/\s+/)[0] || '';
  if (mode === 'anonyme' || !first) return 'Client Weld Rda';
  first = first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
  return mode === 'prenom' ? first : first.charAt(0) + '.';
}
function mode(f) {
  var el = f.querySelector('[data-rev-show]:checked');
  var v = el ? el.value.toLowerCase() : 'initiale';
  return v.indexOf('anon') === 0 ? 'anonyme' : (v.indexOf('pr') === 0 ? 'prenom' : 'initiale');
}
function preview(f) {
  var out = f.querySelector('[data-rev-preview]'), nm = f.querySelector('[data-rev-name]');
  if (!out) return;
  var m = mode(f), n = nm ? nm.value : '';
  out.textContent = (!n.trim() && m !== 'anonyme') ? (m === 'prenom' ? 'Youssef' : 'Y.') : shownName(n, m);
}
function val(f, n) {
  var el = f.querySelector('[name="contact[' + n + ']"]:checked') || f.querySelector('[name="contact[' + n + ']"]:not([type=radio])');
  return el ? el.value.trim() : '';
}
document.addEventListener('input', function (e) {
  if (!e.target.closest || !e.target.closest('[data-wr-review]')) return;
  if (e.target.name === 'contact[phone]') e.target.setCustomValidity('');
  if (e.target.form) preview(e.target.form);
});
document.addEventListener('change', function (e) {
  if (e.target.hasAttribute && e.target.hasAttribute('data-rev-show') && e.target.form) preview(e.target.form);
});
document.addEventListener('submit', function (e) {
  var f = e.target, box = f.closest && f.closest('[data-wr-review]');
  if (!box) return;
  var ph = f.querySelector('[name="contact[phone]"]');
  if (ph && ph.value.replace(/\D/g, '').length < 9) {
    e.preventDefault();
    ph.setCustomValidity('Entrez le numéro utilisé pour la commande (ex. 06 12 34 56 78).');
    ph.reportValidity();
    return;
  }
  var em = f.querySelector('[data-rev-email]'), given = em ? em.value.trim() : '';
  if (em && !given) em.value = box.getAttribute('data-email') || '';
  var d = new Date();
  var code = {
    wr: 1, h: box.getAttribute('data-handle'), r: parseInt(val(f, 'Note'), 10) || 0, b: val(f, 'body'),
    n: val(f, 'name'), s: mode(f), t: val(f, 'Taille achetée'), f: val(f, 'Coupe'), e: given,
    d: ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear()
  };
  var c = f.querySelector('[data-rev-code]');
  if (c) c.value = JSON.stringify(code);
});
}

/* Product page on computer (990px and wider): the photos of the chosen colour fill the left column in a grid
   (odd number: the first photo is big), and each column sticks so that the shorter one stays in view while the
   longer one scrolls. A column taller than the screen sticks by its bottom (negative --wr-stick). */
function initPdpLayout() {
var cols = document.querySelectorAll('.wr-pdp__gallery, .wr-pdp__info');
if (!cols.length) return;
var mq = window.matchMedia('(min-width: 990px)');
function stick() {
  cols.forEach(function (el) {
    if (!mq.matches) { el.style.removeProperty('--wr-stick'); return; }
    el.style.setProperty('--wr-stick', Math.min(24, window.innerHeight - el.offsetHeight - 24) + 'px');
  });
}
function lay(track) {
  var vis = Array.prototype.filter.call(track.children, function (s) { return !s.hidden; });
  Array.prototype.forEach.call(track.children, function (s) { s.classList.remove('is-lead'); });
  if (vis.length % 2 === 1) vis[0].classList.add('is-lead');
}
document.querySelectorAll('.wr-pdp [data-track]').forEach(function (track) {
  lay(track);
  new MutationObserver(function () { lay(track); stick(); }).observe(track, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
});
if ('ResizeObserver' in window) {
  var ro = new ResizeObserver(stick);
  cols.forEach(function (el) { ro.observe(el); });
}
window.addEventListener('resize', stick);
if (mq.addEventListener) mq.addEventListener('change', stick);
stick();
}

/* Product page on phones: photos are 86% wide (next photo peeks out), so the dots and "go to photo"
   use the real slide positions instead of the track width; the description starts closed. */
function initPdpPhone() {
var mq = window.matchMedia('(max-width: 989px)');
var gal = document.querySelector('.wr-pdp [data-wr-gallery]');
if (mq.matches) document.querySelectorAll('.wr-pdp .wr-accs details[open]').forEach(function (d) { d.open = false; });
if (!gal) return;
var track = gal.querySelector('[data-track]'), dots = gal.querySelector('[data-dots]');
if (!track) return;
function vis() { return Array.prototype.filter.call(track.children, function (s) { return !s.hidden; }); }
function index() {
  var list = vis();
  if (!list.length) return 0;
  if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) return list.length - 1;
  var base = list[0].offsetLeft, best = 0, d = Infinity;
  list.forEach(function (s, k) { var x = Math.abs(s.offsetLeft - base - track.scrollLeft); if (x < d) { d = x; best = k; } });
  return best;
}
var raf;
track.addEventListener('scroll', function () {
  if (!mq.matches || !dots) return;
  cancelAnimationFrame(raf);
  raf = requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      var i = index();
      Array.prototype.forEach.call(dots.children, function (dt, k) { dt.classList.toggle('is-active', k === i); });
    });
  });
}, { passive: true });
var orig = gal.goToMedia;
gal.goToMedia = function (mediaId) {
  if (!mq.matches && orig) return orig.call(gal, mediaId);
  var list = vis();
  for (var i = 0; i < list.length; i++) {
    if (String(list[i].getAttribute('data-media-id')) === String(mediaId)) {
      track.scrollTo({ left: list[i].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
      return;
    }
  }
};
}

/* Photo zoom (travail 14): tap or click a product photo to open the photos of the chosen colour full screen.
   Computer: click to zoom (about x2-3), move the mouse to look around, click again to zoom out; arrows or keyboard
   arrows for the next photo; click outside the photo, Escape or x to close.
   Phone: swipe between photos, pinch or double-tap to zoom, drag to move; x or the phone's back button to close. */
function initZoom() {
var gal = document.querySelector('.wr-pdp [data-wr-gallery]');
if (!gal || gal.__wrZoom) return;
gal.__wrZoom = true;
var mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');
var MAX = 4, TAP_ZOOM = 2.5;
var box, track, count, prevBtn, nextBtn, closeBtn, hint, items = [], list = [], idx = -1;
var z = { s: 1, x: 0, y: 0 }, lastFocus = null, pushed = false, hinted = 0;
var ICON = {
  x: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
  l: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
  r: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
};
function fine() { return mqFine.matches; }
function big(src) {
  if (!src) return '';
  return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + 2048) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2048';
}
function slides() {
  return Array.prototype.filter.call(gal.querySelectorAll('[data-track] > .wr-gallery__slide'), function (s) { return !s.hidden && s.querySelector('img'); });
}
function cur() { var s = track && track.children[idx]; return s ? s.firstChild : null; }
function apply(anim) {
  var img = cur();
  if (!img) return;
  img.style.transition = anim ? 'transform .25s ease' : 'none';
  img.style.transform = z.s > 1 ? 'translate3d(' + z.x + 'px,' + z.y + 'px,0) scale(' + z.s + ')' : '';
  box.classList.toggle('is-zoomed', z.s > 1);
}
function clamp() {
  var img = cur();
  if (!img) return;
  var mx = Math.max(0, (img.offsetWidth * z.s - track.clientWidth) / 2);
  var my = Math.max(0, (img.offsetHeight * z.s - track.clientHeight) / 2);
  z.x = Math.min(mx, Math.max(-mx, z.x));
  z.y = Math.min(my, Math.max(-my, z.y));
}
function center() {
  var r = track.getBoundingClientRect();
  return { x: r.left + r.width / 2, y: r.top + r.height / 2, r: r };
}
/* Zoom to s1 keeping the point (px, py) of the screen still. */
function zoomAt(px, py, s1, anim) {
  var c = center();
  s1 = Math.min(MAX, Math.max(1, s1));
  var ux = (px - c.x - z.x) / z.s, uy = (py - c.y - z.y) / z.s;
  z.s = s1; z.x = px - c.x - ux * s1; z.y = py - c.y - uy * s1;
  if (s1 === 1) { z.x = 0; z.y = 0; }
  clamp(); apply(anim);
}
/* Computer: the mouse position chooses which part of the zoomed photo is shown. */
function follow(px, py) {
  var img = cur(), c = center();
  if (!img) return;
  var mx = Math.max(0, (img.offsetWidth * z.s - c.r.width) / 2), my = Math.max(0, (img.offsetHeight * z.s - c.r.height) / 2);
  var fx = Math.min(1, Math.max(0, (px - c.r.left) / c.r.width)), fy = Math.min(1, Math.max(0, (py - c.r.top) / c.r.height));
  z.x = mx * (1 - 2 * fx); z.y = my * (1 - 2 * fy);
}
function unzoom() {
  var img = cur();
  z = { s: 1, x: 0, y: 0 };
  if (img) { img.style.transition = 'none'; img.style.transform = ''; }
  if (box) box.classList.remove('is-zoomed');
}
function load(k) {
  var s = track.children[k];
  if (!s) return;
  var img = s.firstChild, it = items[k];
  if (img.getAttribute('src')) return;
  img.src = it.small || it.big;
  if (it.small && it.big && it.big !== it.small) {
    var hi = new Image();
    hi.onload = function () { img.src = it.big; };
    hi.src = it.big;
  }
}
function show(k) {
  if (k !== idx) unzoom();
  idx = k;
  count.textContent = (k + 1) + ' / ' + items.length;
  prevBtn.disabled = k <= 0;
  nextBtn.disabled = k >= items.length - 1;
  load(k); load(k + 1); load(k - 1);
}
function go(k, smooth) {
  k = Math.max(0, Math.min(items.length - 1, k));
  if (k !== idx) unzoom();
  track.scrollTo({ left: k * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  show(k);
}
function build() {
  box = document.createElement('div');
  box.className = 'wr-zoom';
  box.hidden = true;
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Photos du produit');
  box.innerHTML = '<div class="wr-zoom__track"></div>' +
    '<p class="wr-zoom__count" aria-live="polite"></p>' +
    '<button type="button" class="wr-zoom__btn wr-zoom__close" aria-label="Fermer">' + ICON.x + '</button>' +
    '<button type="button" class="wr-zoom__btn wr-zoom__nav wr-zoom__nav--prev" aria-label="Photo précédente">' + ICON.l + '</button>' +
    '<button type="button" class="wr-zoom__btn wr-zoom__nav wr-zoom__nav--next" aria-label="Photo suivante">' + ICON.r + '</button>' +
    '<p class="wr-zoom__hint" aria-hidden="true"></p>';
  document.body.appendChild(box);
  track = box.querySelector('.wr-zoom__track');
  count = box.querySelector('.wr-zoom__count');
  closeBtn = box.querySelector('.wr-zoom__close');
  prevBtn = box.querySelector('.wr-zoom__nav--prev');
  nextBtn = box.querySelector('.wr-zoom__nav--next');
  hint = box.querySelector('.wr-zoom__hint');
  closeBtn.addEventListener('click', function () { close(false); });
  prevBtn.addEventListener('click', function () { go(idx - 1, true); });
  nextBtn.addEventListener('click', function () { go(idx + 1, true); });
  box.addEventListener('gesturestart', function (e) { e.preventDefault(); });
  var raf;
  track.addEventListener('scroll', function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (k !== idx && k >= 0 && k < items.length) show(k);
    });
  }, { passive: true });
  /* Computer: click = zoom in / out; click outside the photo = close. */
  track.addEventListener('click', function (e) {
    if (!fine()) return;
    var img = e.target.closest && e.target.closest('.wr-zoom__img');
    if (!img) { if (z.s > 1) { unzoom(); apply(true); } else close(false); return; }
    if (z.s > 1) { z = { s: 1, x: 0, y: 0 }; apply(true); return; }
    z.s = Math.min(3, Math.max(2, (img.naturalWidth || 0) / Math.max(1, img.offsetWidth)));
    follow(e.clientX, e.clientY); apply(true);
  });
  box.addEventListener('mousemove', function (e) {
    if (z.s > 1 && fine()) { follow(e.clientX, e.clientY); apply(false); }
  });
  /* Phone: pinch, drag when zoomed, double-tap. */
  var t = null, tap = null, lastTap = null;
  function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1; }
  function panFrom(p) { return { mode: 'pan', sx: p.clientX, sy: p.clientY, x: z.x, y: z.y }; }
  track.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) {
      var a = e.touches[0], b = e.touches[1];
      t = { mode: 'pinch', d: dist(a, b), s: z.s, mx: (a.clientX + b.clientX) / 2, my: (a.clientY + b.clientY) / 2, x: z.x, y: z.y };
      tap = null;
      e.preventDefault();
    } else if (e.touches.length === 1) {
      var p = e.touches[0];
      tap = { x: p.clientX, y: p.clientY, time: Date.now() };
      t = z.s > 1 ? panFrom(p) : null;
    }
  }, { passive: false });
  track.addEventListener('touchmove', function (e) {
    if (tap && e.touches.length === 1 && Math.hypot(e.touches[0].clientX - tap.x, e.touches[0].clientY - tap.y) > 10) tap = null;
    if (!t) return;
    if (t.mode === 'pinch' && e.touches.length === 2) {
      e.preventDefault();
      var a = e.touches[0], b = e.touches[1], c = center();
      var s1 = Math.min(MAX, Math.max(1, t.s * dist(a, b) / t.d));
      var ux = (t.mx - c.x - t.x) / t.s, uy = (t.my - c.y - t.y) / t.s;
      z.s = s1;
      z.x = (a.clientX + b.clientX) / 2 - c.x - ux * s1;
      z.y = (a.clientY + b.clientY) / 2 - c.y - uy * s1;
      clamp(); apply(false);
    } else if (t.mode === 'pan' && e.touches.length === 1) {
      e.preventDefault();
      z.x = t.x + e.touches[0].clientX - t.sx;
      z.y = t.y + e.touches[0].clientY - t.sy;
      clamp(); apply(false);
    }
  }, { passive: false });
  track.addEventListener('touchend', function (e) {
    if (t && t.mode === 'pinch') {
      if (z.s < 1.1) { z = { s: 1, x: 0, y: 0 }; apply(true); }
      t = (e.touches.length === 1 && z.s > 1) ? panFrom(e.touches[0]) : null;
      return;
    }
    if (e.touches.length) return;
    t = null;
    if (!tap || Date.now() - tap.time > 350) { tap = null; return; }
    var now = Date.now();
    if (lastTap && now - lastTap.time < 320 && Math.hypot(tap.x - lastTap.x, tap.y - lastTap.y) < 40) {
      if (e.cancelable) e.preventDefault();
      if (z.s > 1) { z = { s: 1, x: 0, y: 0 }; apply(true); } else zoomAt(tap.x, tap.y, TAP_ZOOM, true);
      lastTap = null;
    } else {
      lastTap = { x: tap.x, y: tap.y, time: now };
    }
    tap = null;
  }, { passive: false });
  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(false); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, true); }
    else if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(box.querySelectorAll('button'), function (b) { return !b.disabled && b.offsetParent !== null; });
      if (!f.length) return;
      e.preventDefault();
      var i = f.indexOf(document.activeElement);
      f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  });
  window.addEventListener('popstate', function () { if (!box.hidden) { pushed = false; close(true); } });
  window.addEventListener('resize', function () {
    if (box.hidden) return;
    unzoom();
    track.scrollTo({ left: idx * track.clientWidth });
  });
}
function open(slide) {
  if (!box) build();
  list = slides();
  if (!list.length) return;
  items = list.map(function (s) {
    var im = s.querySelector('img'), src = im.currentSrc || im.getAttribute('src') || '';
    return { small: im.currentSrc || '', big: big(src), alt: im.getAttribute('alt') || '' };
  });
  track.innerHTML = '';
  items.forEach(function (it) {
    var s = document.createElement('div'), im = document.createElement('img');
    s.className = 'wr-zoom__slide';
    im.className = 'wr-zoom__img';
    im.alt = it.alt;
    im.draggable = false;
    im.decoding = 'async';
    s.appendChild(im);
    track.appendChild(s);
  });
  idx = -1;
  z = { s: 1, x: 0, y: 0 };
  lastFocus = document.activeElement;
  box.classList.toggle('is-single', items.length < 2);
  hint.textContent = fine() ? 'Cliquez sur la photo pour zoomer' : 'Pincez ou touchez deux fois pour zoomer';
  box.classList.toggle('is-hinted', hinted++ > 0);
  box.hidden = false;
  document.documentElement.classList.add('wr-zoom-open');
  var k = Math.max(0, list.indexOf(slide));
  track.scrollLeft = k * track.clientWidth;
  show(k);
  try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
  try { history.pushState({ wrZoom: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
}
function close(fromHistory) {
  if (!box || box.hidden) return;
  var seen = list[idx];
  unzoom();
  box.hidden = true;
  document.documentElement.classList.remove('wr-zoom-open');
  /* Phones: the page slider jumps to the photo that was looked at last (instant, it was behind the viewer). */
  var gt = gal.querySelector('[data-track]'), vis = slides();
  if (seen && gt && vis.length && gt.scrollWidth > gt.clientWidth + 2) gt.scrollTo({ left: seen.offsetLeft - vis[0].offsetLeft, behavior: 'auto' });
  if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  if (pushed && !fromHistory) { pushed = false; try { history.back(); } catch (e) {} }
  pushed = false;
}
/* Open: click or tap a photo (a swipe on the phone slider does not count as a tap), or Enter on a focused photo. */
gal.querySelectorAll('[data-track] > .wr-gallery__slide').forEach(function (s) {
  var im = s.querySelector('img');
  if (!im) return;
  s.setAttribute('role', 'button');
  s.setAttribute('tabindex', '0');
  s.setAttribute('aria-label', 'Agrandir la photo' + (im.alt ? ' : ' + im.alt : ''));
});
gal.addEventListener('click', function (e) {
  var s = e.target.closest && e.target.closest('.wr-gallery__slide');
  if (!s || s.hidden || !s.querySelector('img')) return;
  e.preventDefault();
  open(s);
});
gal.addEventListener('keydown', function (e) {
  var s = e.target;
  if ((e.key === 'Enter' || e.key === ' ') && s.classList && s.classList.contains('wr-gallery__slide') && s.querySelector('img')) {
    e.preventDefault();
    open(s);
  }
});
}

function start() { initCards(); initReviews(); initPdpLayout(); initPdpPhone(); initZoom(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
})();
